import React, { ReactNode } from 'react';
import cx from 'classnames';
import { RoleType } from '@/constants';
import { Collapse } from './Collapse';
import { useCollapsePanel, UseCollapsePanelOptions } from './index.ViewHook';
import { ContentsType } from '@/api/seller/serv/oec_seller_learning_center_api';

interface CollapsePanelProps extends UseCollapsePanelOptions {
  className?: string;
  forSeller: {
    menu: ReactNode;
    content: ReactNode;
  };
  forCreator: {
    menu: ReactNode;
    content: ReactNode;
  };
  rightNode?: ReactNode;
  tab: ContentsType;
}

export const CollapsePanel = ({
  className,
  forSeller,
  forCreator,
  rightNode,
  tab,
  onChange,
}: CollapsePanelProps) => {
  const { activeRole, handleChange } = useCollapsePanel({ onChange });

  return (
    <section className={cx('w-full flex mt-24', className)}>
      <div>
        <Collapse
          className="sticky top-[160px]"
          defaultActiveKey={activeRole}
          sellerNode={forSeller.menu}
          creatorNode={forCreator.menu}
          onChange={handleChange}
          tab={tab}
        />
      </div>
      <div className="flex-1 overflow-hidden">
        {activeRole === RoleType.Seller
          ? forSeller.content
          : forCreator.content}
      </div>
      {rightNode}
    </section>
  );
};
